/**
 * Same rule as trace-web `login-form.schema.ts` `orgCodeValidator`
 * (`/^[a-zA-Z0-9]{5}$/` on trimmed value).
 */
export const ORG_CODE_EXPECTED_LENGTH = 5;

export const ORG_CODE_REGEX = /^[a-zA-Z0-9]{5}$/;

export const ORG_CODE_LENGTH_ERROR_MESSAGE = 'Code must be 5 characters.';

export const ORG_CODE_CHARS_ERROR_MESSAGE = 'Code can only contain numbers and letters.';

/** @param trimmed — caller should pass `value.trim()` */
export function getOrgCodeValidationMessage(trimmed: string): string | null {
    if (trimmed.length !== ORG_CODE_EXPECTED_LENGTH) {
        return ORG_CODE_LENGTH_ERROR_MESSAGE;
    }
    if (!ORG_CODE_REGEX.test(trimmed)) {
        return ORG_CODE_CHARS_ERROR_MESSAGE;
    }
    return null;
}

/** @param trimmed — caller should pass `value.trim()` */
export function isValidOrgCode(trimmed: string): boolean {
    return getOrgCodeValidationMessage(trimmed) === null;
}
